import React from 'react';
import { Hero } from '../components/home/Hero';
import { ProofBand } from '../components/home/ProofBand';
import { Solutions } from '../components/home/Solutions';
import { TemplateVsCustom } from '../components/home/TemplateVsCustom';
import { AiSeoLanes } from '../components/home/AiSeoLanes';
import { EcommerceFees } from '../components/home/EcommerceFees';
import { SupportLoop } from '../components/home/SupportLoop';
import { IndustryWall } from '../components/home/IndustryWall';
import { GuaranteeBand } from '../components/home/GuaranteeBand';
import { GetStarted } from '../components/home/GetStarted';
export function Home() {
  return <>
      <Hero data-id="element-495" data-mp="29i7ybz9lq0f2" />
      <ProofBand data-id="element-496" data-mp="29ihnxlqqi5k8" />
      <Solutions data-id="element-497" data-mp="2dhgt97gdo4c7" />
      <TemplateVsCustom data-id="element-498" data-mp="2dhyvckpq1cs1" />
      <AiSeoLanes data-id="element-499" data-mp="2dja0ooytesl9" />
      <EcommerceFees data-id="element-500" data-mp="2dfm3nfu5vo1s" />
      <SupportLoop data-id="element-501" data-mp="3kvaeit7sgnyp" />
      <IndustryWall data-id="element-502" data-mp="3kvtp1ov40a2p" />
      <GuaranteeBand data-id="element-503" data-mp="3kuihddyjmi6b" />
      <GetStarted data-id="element-504" data-mp="3kv0pp8yhcmul" />
    </>;
}